import { createActionGroup, props } from '@ngrx/store';
import { ValueType } from '@ra-web-tech-ui-toolkit/components';
import { ToggleDateFilter } from 'src/app/core/models/alarm.model';
import { Shift } from 'src/app/core/models/configuration.model';

export const AlarmKPIPageActions = createActionGroup({
  source: 'Alarms KPI Page',
  events: {
    'Update Toggle Date Filter': props<{
      toggleDateFilter: ToggleDateFilter;
    }>(),
    'Set Date Filter': props<{ dateFilter: string }>(),
    'Set Area Filter': props<{ areaFilter: ValueType }>(),
    'Set Group Filter': props<{ groupFilter: ValueType }>(),
    'Set Shift Filter': props<{ shiftFilter: Shift }>(),
    'Set Top Bad Actors View': props<{ value: number; index: number }>(),
  },
});
